import { render, staticRenderFns } from "./customslist.vue?vue&type=template&id=6403711a"
import script from "./customslist.vue?vue&type=script&lang=js"
export * from "./customslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports